import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";
import Chip from "@mui/material/Chip";
import { projects } from "../../apis/apisList/userApi";
import { toast } from "react-toastify";
import CustomLoader from "../CustomLoader";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { IconButton, Tooltip } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getChipProps, getUserStatusLable } from "../../config/helper";

export default function ProjectFiles() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const admin = localStorage.getItem("admin");
  const handleFileDownload = async (project) => {
    toast.success("Downloading files...", {
      autoClose: 2000,
      toastId: "downloading",
    });

    try {
      project.files.forEach(({ name, url }) => {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name); // Optional: Some browsers ignore this for external links
        // link.target = "_blank"; // Opens in a new tab
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    } catch (error) {
      toast.dismiss("downloading");
      toast.error("Error downloading files");
      console.error("Error downloading files:", error);
    } finally {
      toast.dismiss("downloading");
    }
  };

  useEffect(() => {
    const getProjects = async () => {
      try {
        const { results } = await projects({ status: "accepted,completed" });
        setRows(results);
      } catch (error) {
        console.error(error);
        setRows([]);
      } finally {
        setLoading(false);
      }
    };
    getProjects();
  }, []);

  const cellStyle = {
    color: "#064776 !important",
    fontWeight: 600,
  };

  if (loading) {
    return <CustomLoader loading={loading} />;
  }
  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        overflowX: "auto",
        borderRadius: "10px",
        boxShadow: "none",
      }}
    >
      <Table
        sx={{
          width: "100%",
          "& thead": {
            backgroundColor: "#EBEBEB",
          },
          "& tbody": {
            backgroundColor: "#F8F8F8",
          },
          "& .MuiTableCell-root": {
            borderBottom: `1px solid #E0E0E0`,
          },
        }}
        aria-label="project files table"
      >
        <TableHead>
          <TableRow>
            <TableCell sx={cellStyle}>Project Name</TableCell>
            <TableCell sx={cellStyle}>Address</TableCell>
            <TableCell sx={cellStyle}>Date</TableCell>
            <TableCell sx={cellStyle}>Status</TableCell>
            <TableCell sx={cellStyle}>Pricing</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length ? (
            rows.map((row) => (
              <TableRow
                key={row._id}
                onClick={() => {
                  navigate(
                    admin
                      ? `/admindashboard/project/${row._id}`
                      : `/dashboard/project/${row._id}`
                  );
                }}
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    bgcolor: "#80808014",
                  },
                }}
              >
                <TableCell
                  style={{
                    width: "500px",
                  }}
                >
                  {row.name}
                </TableCell>
                <TableCell
                  style={{
                    width: "400px",
                  }}
                >
                  {row.address || "N/A"}
                </TableCell>
                <TableCell>{row.date || "N/A"}</TableCell>
                <TableCell>
                  <Chip
                    label={getUserStatusLable(row.status, row.userStatus)}
                    variant="outlined"
                    size="small"
                    sx={{
                      textTransform: "capitalize",
                    }}
                    {...getChipProps(row.status, row.userStatus)}
                  />
                </TableCell>
                <TableCell>${row.price}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6}>No Completed Projects</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
